var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cc-button",class:{
    'disabled': _vm.disabled
}},[_c('button',{style:({
        'border-radius': _vm.borderRadius,
        'background-color': _vm.bgColor
    }),on:{"click":function($event){$event.stopPropagation();return _vm.clickHandler.apply(null, arguments)}}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }